import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { translate } from '../../../Services/translation';
import { handleTermsAndConditionsAccepted } from '../../../Actions/Login.action';
import EditorString from '../../EditorString';
import Input from './../../Input';

const TermsAndConditions = (props) => {
  const dispatch = useDispatch();
  const { terms } = props;
  const [acceptMarketing, setAcceptMarketing] = useState(false);

  const tncAccepted = (fields) => {
    dispatch(handleTermsAndConditionsAccepted(fields));
  }

  return (
    <div className="terms">
      <EditorString value={terms} />
      <div className="input-field-wrapper">
        <Input
          id="acceptMarketing"
          type="checkbox"
          wrapperClassName="terms__input-checkbox-wrapper"
          className="terms__input-checkbox"
          checked={acceptMarketing}
          onChange={() => setAcceptMarketing(!acceptMarketing)}
          label={translate('general.accept-marketing-terms')}
        />
      </div>
      <button
        className="login__submit-button login__submit-button-terms"
        onClick={() =>
          tncAccepted({
            acceptMarketing,
          })
        }
      >
        {translate('general.accept-terms')}
      </button>
    </div>
  );
};

export default TermsAndConditions;
